import { createContext, useContext } from 'react';
import useAddCaseForm from '../hooks/useAddCaseForm';

const AddCaseFormContext = createContext(null);

export const AddCaseFormProvider = ({ children }) => {
  const formState = useAddCaseForm();

  return (
    <AddCaseFormContext.Provider value={formState}>
      {children}
    </AddCaseFormContext.Provider>
  );
};

export const useAddCaseFormContext = () => {
  const context = useContext(AddCaseFormContext);

  if (!context) {
    throw new Error('useAddCaseFormContext must be used within AddCaseFormProvider');
  }


  return context;
};

export default AddCaseFormContext;